module.exports = __webpack_public_path__ + "img/btn_shouh.9e6b504b.png";